var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeapons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M96,329.4l50.7-50.7,86.6,86.6-50.7,50.7,20.7,20.7c6.2,6.2,6.2,16.4,0,22.6l-16,16c-4.7,4.7-11.8,6-17.8,3.3l-62-27.5-56.2,56.2c-6.2,6.2-16.4,6.2-22.6,0l-24-24c-6.2-6.2-6.2-16.4,0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1,3.3-17.8l16-16c6.2-6.2,16.4-6.2,22.6,0l20.7,20.7ZM484.5,114.2l-119.2,119.2-86.6-86.6L397.8,27.5c6.7-6.7,15.2-11.3,24.5-13.1L492.9,.3c5.2-1,10.7,.6,14.5,4.4,3.8,3.8,5.4,9.2,4.4,14.5l-14.2,70.4c-1.9,9.3-6.4,17.8-13.1,24.5v.1ZM4.7,4.7C8.5,.9,13.9-.7,19.1,.3L89.6,14.4c9.3,1.9,17.8,6.4,24.5,13.1L393.4,306.7l-86.6,86.6L27.5,114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3,19.1C-.7,13.9,.9,8.5,4.7,4.7ZM459.3,308.7l16,16c4.7,4.7,6,11.8,3.3,17.8l-27.5,62,56.2,56.2c6.2,6.2,6.2,16.4,0,22.6l-24,24c-6.2,6.2-16.4,6.2-22.6,0l-56.2-56.2-62,27.5c-6.1,2.7-13.1,1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4,0-22.6l128-128c6.2-6.2,16.4-6.2,22.6,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeapons);
export default __webpack_public_path__ + "static/media/weapons.eab70d072fbf83892d7511f8e365d955.svg";
export { ForwardRef as ReactComponent };